import StarBurst from './StarBurst';

export default class CharacterSlotHide extends Phaser.Group {
  constructor(game, characterId) {
    super(game);

    this.characterId = characterId;
    this.isGoingUp = false;

    //
    this.createContent();

    //
    this.startX = 0;
    this.startY = 0;
    this.isDown = false;
    this.charHide.inputEnabled = true;
    this.charHide.input.useHandCursor = true;
    this.charHide.events.onInputDown.add(this.handleInputDown, this);
    this.charHide.events.onInputUp.add(this.handleInputUp, this);
    this.charHide.events.onInputOver.add(this.handleInputOver, this);
    this.charHide.events.onInputOut.add(this.handleInputOut, this);

    //
    this.setStateInitial();
  }

  createContent() {
    this.empty = this.game.make.image(0, 0, 'ui_character_icons', 'empty_hide');
    this.empty.anchor.set(0.5);
    this.charHide = this.game.make.image(0, 0, 'ui_character_icons', this.characterId + '_hide');
    this.charHide.anchor.set(0.5);
    this.charHidden = this.game.make.image(
      0,
      0,
      'ui_character_icons',
      this.characterId + '_hidden'
    );
    this.charHidden.anchor.set(0.5);
    this.charFound = this.game.make.image(0, 0, 'ui_character_icons', this.characterId + '_found');
    this.charFound.anchor.set(0.5);

    // arrow
    this.arrow = this.game.make.sprite(0, 45, 'ui_character_icons', 'arrow_hide_01');
    this.arrow.anchor.set(0.5, 0);
    const frames = Phaser.Animation.generateFrameNames('arrow_hide_', 1, 4, '', 2);
    this.arrow.animations.add('loop', frames, 4, true, false);
    this.arrow.play('loop');

    //
    this.addChild(this.empty); // 0
    this.addChild(this.charHide); // 1
    this.addChild(this.charHidden); // 2
    this.addChild(this.charFound); // 3
    this.addChild(this.arrow); // 3

    //
    this.empty.visible = false;
    this.charHidden.visible = false;
    this.charFound.visible = false;
  }

  setStateInitial() {
    this.charHide.input.enabled = true;

    this.charHide.visible = true;
    this.empty.visible = false;
    this.charHidden.visible = false;
    this.charFound.visible = false;
    this.arrow.alpha = 1;
    this.scale.set(1);
  }

  setStateDrag() {
    this.charHide.input.enabled = false;

    this.charHide.visible = false;
    this.empty.visible = true;
    this.charHidden.visible = false;
    this.charFound.visible = false;
    this.arrow.alpha = 0;
  }

  setStateHidden() {
    this.charHide.input.enabled = false;

    this.charHide.visible = false;
    this.empty.visible = false;
    this.charHidden.visible = true;
    this.charFound.visible = false;
    this.arrow.alpha = 0;
    this.scale.set(1);
  }

  setArrowVisibility(visible) {
    this.arrow.visible = visible;
  }

  setArrowsAnim(state) {
    this.arrow.animations.paused = !state;
  }

  setStateClue() {
    // this.frame.visible = false;
    // this.frameClue.visible = true;
  }

  // state for result overlay
  setStateResult() {
    this.setStateHidden();
    this.charHidden.inputEnabled = true;
    this.charHidden.input.useHandCursor = true;
    this.charHidden.events.onInputDown.add(this.handleInputDownResult, this);
    this.onTap = new Phaser.Signal();
  }

  lockResult() {
    this.charHidden.input.enabled = false;
  }

  unlockResult() {
    this.charHidden.input.enabled = true;
  }

  lock() {
    this.charHide.input.enabled = false;
  }

  unlock() {
    this.charHide.input.enabled = true;
  }

  handleInputOver() {
    this.scale.set(1.1);
  }

  handleInputOut() {
    this.scale.set(1);
  }

  handleInputDown(target, pointer) {
    this.pointer = pointer;
    this.isDown = true;
    this.startX = pointer.x;
    this.startY = pointer.y;

    //
    this.game.state.getCurrentState().removeCurrentDragCharacter();
  }

  handleInputUp() {
    if (this.isDown) {
      this.pickUp();
    }
  }

  pickUp() {
    this.game.sounds.playSFX('remove', { spriteID: 'sfx_gameplay', volume: 0.8 });

    this.game.state
      .getCurrentState()
      .startDragCharacter(
        this.characterId,
        this,
        null,
        -1,
        this.worldPosition.x,
        this.worldPosition.y,
        this.pointer
      );

    this.isDown = false;
    this.pointer = null;
  }

  handleInputDownResult() {
    this.onTap.dispatch(this);
  }

  revealCharacter() {
    this.stopPulse();

    this.charHide.visible = false;
    this.empty.visible = false;
    this.charHidden.visible = false;
    this.charFound.visible = true;

    this.game.add
      .tween(this.scale)
      .to({ x: [1.2, 1], y: [1.2, 1] }, 400, Phaser.Easing.BackOut, true)
      .onComplete.add(this.goUp, this);

    //
    this.starBurst = new StarBurst(this.game);
    this.addChild(this.starBurst);
  }

  goUp() {
    this.game.add.tween(this).to({ y: -200 }, 300, Phaser.Easing.Back.In, true, 200);
    this.isGoingUp = true;
  }

  enlarge() {
    this.stopPulse();
    this.game.add.tween(this.scale).to({ x: 1.2, y: 1.2 }, 200, Phaser.Easing.BackOut, true);
  }

  normalize() {
    this.stopPulse();
    this.game.add.tween(this.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.BackOut, true);
  }

  pulse(repeat) {
    this.pulseTween = this.game.add
      .tween(this.scale)
      .to({ x: [1.2, 1], y: [1.2, 1] }, 800, Phaser.Easing.BackOut, true, 0, repeat);
  }

  stopPulse() {
    if (this.pulseTween) {
      this.pulseTween.stop();
      this.pulseTween = false;
    }
  }

  update() {
    if (this.x !== this.destX && !this.isGoingUp) {
      this.x += (this.destX - this.x) * 0.2;
    }

    // start drag
    if (this.isDown) {
      const dx = Math.abs(this.pointer.x - this.startX);
      const dy = Math.abs(this.pointer.y - this.startY);
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist > 20) {
        this.pickUp();
      }
    }

    //
    super.update();
  }

  destroy() {
    this.stopPulse();
    this.empty.destroy();
    this.charHide.destroy();
    this.charHidden = null;
    this.charFound = null;
    super.destroy();
  }
}
